import React, { useState, useEffect } from "react";
import "../styles/AdminUnlockDialog.css";

interface AdminUnlockDialogProps {
  isVisible: boolean;
  onClose: () => void;
}

export default function AdminUnlockDialog({ isVisible, onClose }: AdminUnlockDialogProps) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  // Listen for admin unlock request from Electron
  useEffect(() => {
    if (!window.electron) return;

    window.electron.onShowAdminUnlock(() => {
      // Dialog visibility will be handled by parent component
    });

    window.electron.onAdminUnlockResult((result) => {
      setIsLoading(false);
      if (result.success) {
        setPassword("");
        setError(null);
        // Dialog will be closed by parent after unlock
      } else {
        setError(result.message || "Incorrect password");
      }
    });
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    if (!window.electron) {
      setError("Electron API not available");
      setIsLoading(false);
      return;
    }

    // Send password to main process
    window.electron.unlockAdmin(password);
  };

  const handleCancel = () => {
    setPassword("");
    setError(null);
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className="admin-unlock-overlay">
      <div className="admin-unlock-dialog">
        <div className="admin-unlock-header">
          <h2>Admin Mode</h2>
          <p className="admin-unlock-subtitle">Enter admin password to unlock</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-unlock-form">
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              disabled={isLoading}
              autoFocus
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            <button
              type="button"
              onClick={handleCancel}
              disabled={isLoading}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading || password.length === 0}
              className="btn btn-primary"
            >
              {isLoading ? "Unlocking..." : "Unlock"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
